import { render, staticRenderFns } from "./CustomScoreSimpleData.vue?vue&type=template&id=354a369b&"
import script from "./CustomScoreSimpleData.vue?vue&type=script&lang=js&"
export * from "./CustomScoreSimpleData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports